import { render } from "./Notes.vue?vue&type=template&id=45b493a9&scoped=true&ts=true"
import script from "./Notes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notes.vue?vue&type=script&setup=true&lang=ts"

import "./Notes.vue?vue&type=style&index=0&id=45b493a9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b493a9"],['__file',"src/components/sgre/Notes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b493a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b493a9', __exports__)) {
    console.log('reload')
    api.reload('45b493a9', __exports__)
  }
  
  module.hot.accept("./Notes.vue?vue&type=template&id=45b493a9&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('45b493a9', render)
  })

}


export default __exports__